import React, { Component } from 'react';
import InitialPage from './components/InitialPage';
import Wizard from './components/Wizard.js';
import Footer from './components/Footer.js';
import UtilityModal from './components/UtilityModal.js';
import Report from './components/Report/Report.js';
import Provider from './entities/Provider.js';
import Consumer from './entities/Consumer.js';
import { toBeRequired } from '@testing-library/jest-dom';


class App extends Component { 
    constructor(props){
        super(props);
        this.state = {
            userInfo: "null"
        }

        this.setUserInfo = this.setUserInfo.bind(this);
    }

	componentDidMount() {
		if (process.env.REACT_APP_CLIENT === 'grpaa') {
			require('./style/grpaa-index.scss')
		} else {
			require('./style/index.scss')
		}
	}

    setUserInfo(userInfo){
        this.setState({ userInfo });
    }

    render() {  

            //!this.state.userInfo
		//console.log(process.env.REACT_APP_CLIENT)

        if (!this.state.userInfo) {
            return (                            
                <Provider>   
                    <Consumer>                               
                        <InitialPage setUserInfo={this.setUserInfo} />
                        <UtilityModal />
                    </Consumer>           
                </Provider>
            );
        }else{        
            return (                            
                <Provider userInfo={this.state.userInfo}>   
                    <Consumer>                               
                        <Wizard/>                
                        <Footer />
                        <UtilityModal />
                        <Report />
                    </Consumer>           
                </Provider>
            );
        }
    }
}

export default App;
